import { Col, Row } from "antd";
import { ReactNode, useMemo } from "react";
import { getFormattedCurrency } from "../../../../../../../lib/currencyFormatter";
import { PaySection } from "../PaySection";
import { PrintCouponBtn } from "../PintCouponBtn";
import { AutoWithDrawal } from "./AutoWithdrawal";
import { NoStatus } from "./NoStatus";
import { useGetDateDiff } from "../hooks/useGetDateDiff";
import { useGetContractRole } from "../../../../../../../lib/hooks/getContractRole";

type NextPaymentProps = {
  data: any;
  generalInfo: any;
};

export const NextPayment = ({ data, generalInfo }: NextPaymentProps) => {
  const noDataStatuses: string[] = useMemo(
    () => ["Cancelled", "Replaced", "Default", "Paid Off", "Archived"],
    [],
  );

  const { date } = useGetDateDiff(data);

  const { getContractRole } = useGetContractRole();
  const { isPrimary, isBuyer } = getContractRole(generalInfo);

  const pastDueValue: ReactNode = useMemo(() => {
    const { diff } = date;

    const daysLabel: string = `day${diff !== 1 ? "s" : ""}`;

    return (
      <span className={`${diff > 0 ? "error" : ""} text-md w-500`}>
        {diff <= 0 ? "in" : ""} {Math.abs(diff)}{" "}
        <span className="full-days">{daysLabel}</span>
        <span className="short-days">d</span> {diff > 0 ? "late" : ""}
      </span>
    );
  }, [date]);

  return (
    <>
      {noDataStatuses.includes(generalInfo.status) ? (
        <NoStatus status={generalInfo.status} />
      ) : (
        <Row className="flex-column justify-space-between h-100">
          <Row className="d-block">
            <Row className="justify-space-between align-center mb-2">
              <p className="my-0 text-md title due-label elipsis">
                Payment Due {pastDueValue}
              </p>
              <span className="text w-500">{date.value}</span>
            </Row>
            <Row className="justify-space-between align-center mb-4">
              <p className="my-0 text-md title">Regular Amount</p>
              <span className="text w-500 amount-val elipsis">
                {getFormattedCurrency(data.amount)}
              </span>
            </Row>
            {isPrimary && isBuyer && (
              <AutoWithDrawal autoChargeFlag={generalInfo.autoChargeFlag} />
            )}
          </Row>
          {isBuyer && (
            <Row className="align-center mt-4 justify-space-between">
              <Col className="pay-container">
                <PaySection
                  allowOnlinePayments={generalInfo.allowOnlinePayments}
                />
              </Col>
              <Col className="pl-2">
                <Row className="justify-end">
                  <PrintCouponBtn accountNumber={generalInfo.accountNumber} />
                </Row>
              </Col>
            </Row>
          )}
        </Row>
      )}
    </>
  );
};
